import classes from "./CartItem.module.css";

const CartItem = (props) => {
  //const price = `€${props.aankoopprijs.toFixed(2)}`;
  //const price = `€${props.aankoopprijs}`;

  return (
    <li className={classes["cart-item"]}>
      <div>
        <h2>{props.naam}</h2>
        <div className={classes.summary}>
          <span className={classes.price}>{props.aankoopprijs}</span>
          <span className={classes.amount}>x {props.aankoophoeveelheid}</span>
        </div>
      </div>
      <div className={classes.actions}>
        <button onClick={props.onRemove}>−</button>
        <button onClick={props.onAdd}>+</button>
      </div>
    </li>
  );
};

export default CartItem;